import { render, staticRenderFns } from "./fenyong.vue?vue&type=template&id=db5a4962&scoped=true&"
import script from "./fenyong.vue?vue&type=script&lang=js&"
export * from "./fenyong.vue?vue&type=script&lang=js&"
import style0 from "./fenyong.vue?vue&type=style&index=0&id=db5a4962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5a4962",
  null
  
)

export default component.exports